import { Text, Link } from '@cash-me/react-components'

import { ItemType } from 'modules/help'
import { pushDataLayer } from 'utils/push-data-layer'

const handleClickContact = () => {
  pushDataLayer({
    category: 'Clique',
    action: 'Botões',
    label: 'Accordeon Pergunta: Qual a taxa de juros do Home Equity? - Fale Conosco'
  })

  location.href = 'http://www.cashme.com.br/fale-conosco'
}

export const accordion = [
  {
    id: 'faq-0',
    title: 'O que é Home Equity?',
    item: [
      {
        id: '1',
        type: 'text' as ItemType,
        content: `Home equity é o empréstimo com garantia de imóvel, por meio do qual se oferece um 
        bem imóvel como garantia para o banco ou instituição financeira em troca do crédito solicitado.`
      }
    ]
  },
  {
    id: 'faq-1',
    title: 'O que é alienação fiduciária?',
    item: [
      {
        id: '1',
        type: 'text' as ItemType,
        content: `A alienação fiduciária é uma modalidade de crédito que acontece a partir de um 
        acordo firmado entre o credor e o cliente, a fim de que o imóvel seja colocado como garantia 
        em troca do crédito. Assim, o credor vincula em seu nome a documentação legal do bem, mas o 
        contratante mantém o direito de posse direta, isto é, ele poderá continuar usufruindo do imóvel 
        como moradia. Nesse caso, o fiduciário é a CashMe e o contratante, o cliente. Após a dívida ser 
        totalmente quitada, o imóvel colocado como garantia volta a ser de propriedade total do devedor.`
      }
    ]
  },
  {
    id: 'faq-2',
    title: 'Qual tipo de imóvel eu posso oferecer como garantia no Home Equity?',
    item: [
      {
        id: '1',
        type: 'text' as ItemType,
        content: `Não importa o tipo do imóvel. Podem ser oferecidos como garantia: casas, 
        apartamentos, salas comerciais, terrenos, entre outros. O mais importante é que o imóvel 
        esteja com a documentação devidamente regularizada.`
      }
    ]
  },
  {
    id: 'faq-3',
    title: 'Qual a taxa de juros do Home Equity?',
    item: [
      {
        id: '1',
        type: 'node' as ItemType,
        content: (
          <Text size="body2" color="var(--colors-neutral-text-weak)">
            Na CashMe, oferecemos opções pré e pós-fixadas. Para saber mais, entre em contato com a gente{' '}
            <Link onClick={handleClickContact} size="default">
              <Text as="span" size="body2" color="var(--colors-blue-text-default)">
                aqui
              </Text>
            </Link>
            .
          </Text>
        )
      }
    ]
  },
  {
    id: 'faq-4',
    title: 'É possível solicitar o empréstimo Home Equity com imóvel financiado?',
    item: [
      {
        id: '1',
        type: 'text' as ItemType,
        content: `Sim. No momento da solicitação do empréstimo, é preciso somar o saldo devedor do seu 
        financiamento ao valor que você irá solicitar. Ele não pode ultrapassar 60% do valor de 
        avaliação do seu imóvel.`
      }
    ]
  },
  {
    id: 'faq-5',
    title: 'Regras do Home Equity',
    item: [
      {
        id: '1',
        type: 'text' as ItemType,
        content: `Para obter empréstimo na modalidade de Home Equity, a CashMe exige que as seguintes 
        regras sejam cumpridas:`
      },
      {
        id: '2',
        type: 'list' as ItemType,
        content: [
          {
            id: '1',
            content: 'Valor mínimo do imóvel: R$ 250 mil;'
          },
          {
            id: '2',
            content: 'Valor mínimo solicitado: R$ 50 mil;'
          },
          {
            id: '3',
            content: 'Valor máximo solicitado: até 60% do valor do imóvel;'
          },
          {
            id: '4',
            content: 'Prazo máximo para pagamento: até 240 meses para pagar;'
          },
          {
            id: '5',
            content: 'Uso dos recursos: livre para você fazer o que quiser ou precisar;'
          },
          {
            id: '6',
            content: 'Taxas pré e pós-fixadas.'
          }
        ]
      }
    ]
  },
  {
    id: 'faq-6',
    title: 'Documentos solicitados',
    item: [
      {
        id: '1',
        type: 'list' as ItemType,
        content: [
          {
            id: '1',
            content: 'RG (original e cópia);'
          },
          {
            id: '2',
            content: 'CPF (original e cópia);'
          },
          {
            id: '3',
            content: `Comprovante de estado civil (Certidão de Nascimento - para solteiros; 
            Certidão de Casamento - para casados);`
          },
          {
            id: '4',
            content: 'Comprovante de renda (holerites, declaração do Imposto de Renda, extratos bancários);'
          },
          {
            id: '5',
            content: 'Comprovante de residência;'
          },
          {
            id: '6',
            content: 'Documentos do imóvel: matrícula e IPTU.'
          }
        ]
      }
    ]
  }
]
